import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class DatatableColumnStylingModel extends CoreStylingModel {
/**
 * Styling of header by StylingModel
 */
header?: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function DatatableColumnStylingModel_tsickle_Closure_declarations() {
/**
 * Styling of header by StylingModel
 * @type {?}
 */
DatatableColumnStylingModel.prototype.header;
}

